import React, { useContext, useEffect, useState } from "react";
import imagesLoaded from "imagesloaded";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import MediaOne from "./partials/media/media-one";
import ProductDetailOne from "./partials/details/detail-one";
import DescOne from "./partials/description/desc-one";
import ModalInfo from "react-modal";
import Breadcrumb from "../../common/breadcrumb";
import "./default.css";
import { productGallery } from "../../../utils";
import {
  getEventById,
  findEventByAlias,
} from "../../../services/EventsService";
import { getActiveCouponInter } from "../../../services/CouponService";
import {InitializeGoogleAnalytics, TrackGoogleAnalyticsEvent}  from "../../../utils/google-analytics/index";

import { AuthContext } from "../../../context/AuthProvider";
const instagramIphone = "assets/images/instagram-iphone.png";
const instagramAndroid = "assets/images/instagram-android.png";

function SingleProduct(props) {
  const { setRefer } = useContext(AuthContext);

  let eventId = props.match.params.id;
  let alias = null;
  if (!eventId) {
    alias = props.match.params.alias;
  }

  const [event, setEvent] = useState();
  const [prevOrder, setPrevOrder] = useState();
  const [couponInter, setCouponInter] = useState(null);
  const [bannerInter, setBannerInter] = useState(null);
  const containerStyle = {
        position: 'relative',
        width: '100%', // Defina o tamanho desejado para a imagem
        // paddingBottom: '5px', // Defina o tamanho desejado para a imagem
        marginBottom: '50px',
      };
    
      const textStyle = {
        width: "100px", // Defina o tamanho desejado para o texto
        position: 'absolute',
        top: '71%', // Ajuste a posição vertical para o centro da imagem
        left: '47.8%', // Ajuste a posição horizontal para o centro da imagem
        transform: 'translate(-50%, -50%)', // Centralize o texto usando transform
        color: 'black', // Cor do texto
        fontSize: '1.3vw', // Tamanho da fonte relativo à largura da tela
        fontWeight: 'bold',
        textAlign: 'center',
        whiteSpace: 'nowrap', // Impede a quebra de linha no texto
      };

  useEffect(() => {
    // InitializeGoogleAnalytics();
    const sync = async () => {
      let event = null;
      if (eventId) {
        event = await getEventById(eventId, true);
      } else {
        event = await findEventByAlias(alias, true);
      }
      const refer = new URLSearchParams(props.location.search).get("ref");
      if (refer) {
        setRefer(refer);
      }
      console.log("event dataaaa", event)
      setEvent(event.data);
      const couponInter = await getActiveCouponInter(event.data.id);
      // console.log("couponInter", couponInter)
      if (couponInter.data) {
        const code = couponInter.data.code;
        setCouponInter(code.split("-")[1]);
        if (code.startsWith('INTER$-')) {
          setBannerInter('/assets/images/inter/inter-dinamic.png');
        }
        else if(code.startsWith('INTERT-')) {
          setBannerInter('/assets/images/inter/inter-ticket.png');
        }
      }
      if (!event) {
        window.location = process.env.PUBLIC_URL + "pages/404";
      }
    };
    sync();
    productGallery();

    let skelProSingle = document.querySelector(".skel-pro-single");
    if(skelProSingle)
      skelProSingle.classList.remove("loaded");
    let imgLoad = imagesLoaded(".product-main-image", { background: true });
    imgLoad.on("done", function (instance, image) {
      if(skelProSingle)
        skelProSingle.classList.add("loaded");
    });

    if (props.location.state && props.location.state.order) {
      setPrevOrder(props.location.state.order.auxTickets);
    }
  }, []);

  
  // const teste = () => {
  //   // TrackGoogleAnalyticsEvent = (category, action, label)

  //   console.log("teste")
  //   TrackGoogleAnalyticsEvent('Inter', 'Click', 'Banner');
    
    
  // }
  const oneClickToGA = () => {
    TrackGoogleAnalyticsEvent('Inter', 'Custom Click', 'Banner - ' + event.id )
  }


  const userAgent = navigator.userAgent;
  const infoStyles = {
    content: {
      top: "50%",
      // left: "50%",
      right: "auto",
      bottom: "auto",
      transform: "translate(-5%, -50%)",
      borderRadius: "20px",
      
    },
  };
  return (
    <>
      {/* {userAgent.includes("Instagram") && userAgent.includes("iPhone") &&
      <span>
        <ModalInfo isOpen={true} style={infoStyles}>
          <h2 className="icon-box-title text-primary">Instructions</h2>
          <p>To access our ticket purchase page from Instagram, please follow these steps:</p>
          <br />
          <p>Click on the <strong>'Menu'</strong> button (<strong>three dots '...'</strong>) in the top-right corner of the Instagram screen.</p>
          <br />
          <p>Select <strong>'Open in system browser'</strong> from the menu options.</p> <br/>
          <img src={`${process.env.PUBLIC_URL}/${instagramIphone}`} alt="Groovoo Logo" />
        </ModalInfo>
      </span>}

      {userAgent.includes("Instagram") && userAgent.includes("Android") &&
      <span>
        <ModalInfo isOpen={true} style={infoStyles}>
          <h2 className="icon-box-title text-primary">Instructions</h2>
          <p>To access our ticket purchase page from Instagram, please follow these steps:</p>
          <br />
          <p>Click on the <strong>'Menu'</strong> button (<strong>three dots '&#8942;'</strong>) in the top-right corner of the Instagram screen.</p>
          <br />
          <p>Select <strong>'Open in Chrome'</strong> from the menu options.</p> <br/>
          <img src={`${process.env.PUBLIC_URL}/${instagramAndroid}`} alt="Groovoo Logo" />
        </ModalInfo>
      </span>} */}

      {/* {!userAgent.includes("Instagram") && */}
      <>
      <Helmet>
        <title>Groovoo Ticketing </title>
      </Helmet>
      <h1 className="d-none">Groovoo Ticketing </h1>
      <div className="main">
        <Breadcrumb
          title={event ? event.name : "Event"}
          type="product"
          adClass="breadcrumb-nav border-0 mb-0"
          productId={eventId}
          parent1={["Events", "events"]}
        />

        <div className="page-content">
          <div className="container">
            <div style={containerStyle}>
              {/* <a onClick={oneClickToGA} href={'https://bancointer.go.link/globalAccount/remittance?adj_t=14sbwzei&adj_adgroup=groovoo_tickets_banner_website'} target="_blank" rel="noopener noreferrer"> */}
                {/* <img
                    src={process.env.PUBLIC_URL + ('https://s3.groovoo.io/utils/banner_home.png')}
                    alt="banner_home"
                    style={{ width: '100%', height: 'auto' }}
                /> */}
              
                {/* <div style={textStyle}>
                    {couponInter ? couponInter : 'GRV'}
                </div> */}
              {/* </a> */}
            </div>
            <div className="product-details-top skeleton-body">
              <div className="row skel-pro-single">
                <div className="col-md-6">
                  <div className="skel-product-gallery"></div>

                  {event && event.images && <MediaOne event={event} />}
                </div>

                <div className="col-md-6">
                  <div className="entry-summary row">
                    <div className="col-md-12">
                      <div className="entry-summary1"></div>
                    </div>

                    <div className="col-md-12">
                      <div className="entry-summary2"></div>
                    </div>
                  </div>

                  {event && (
                    <ProductDetailOne event={event} prevOrder={prevOrder} />
                  )}
                </div>
              </div>
            </div>

            {event && <DescOne event={event} />}

          </div>
        </div>
      </div>
      </>
      {/* End checking userAgent} */}
    </>
  );
}

export default SingleProduct;
